"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTextResources = getTextResources;
const localeMap = {
    "en-UK": "en-GB",
};
function getTextResources(locale) {
    const ret = {};
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const fallbackResources = require(`../i18n/fallback.i18n.json`);
    for (const [key, value] of Object.entries(fallbackResources)) {
        ret[key] = value;
    }
    // Fallback to german
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    let textResources = require(`../i18n/de-DE.i18n.json`);
    for (const [key, value] of Object.entries(textResources)) {
        ret[key] = value;
    }
    // locale specific i18n.resource
    try {
        if (localeMap[locale]) {
            textResources = require(`../i18n/${localeMap[locale]}.i18n.json`);
        }
        else {
            textResources = require(`../i18n/${locale}.i18n.json`);
        }
        for (const [key, value] of Object.entries(textResources)) {
            ret[key] = value;
        }
    }
    catch (e) {
        // eslint-disable-next-line no-console
        console.log(`no text resources found for ${locale}`);
    }
    return ret;
}
